import { useCheckUserType } from '@/src/hooks/check_user'
import { RootState } from '@/src/redux/store'
import { useSelector } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router-dom'
import WarehouseRoot from '../warehouse/page'
import { AddProduct } from './add_product/add_product/page'
import { AddProductSKU } from './add_product_sku/page'
import { BrandCRUD } from './brand_crud/page'
import { EcommercStockCRUD } from './ecommStock/page'
import { ExcelUploadPrice } from './price_upload/priceUpload'
import { CategoryCRUD } from './product_category/page'
import { PurchaseList } from './purchase/page'
import { StockCRUD } from './stock/page'
import { ExcelUpload } from './stockUpload/stockUpload'

type Props = {
  setSelectedId: (id: string) => any
}

export default function EcommerceRoot(props: Props) {

  const { isSEOs } = useCheckUserType()

  const employee = useSelector((state: RootState) => state.employee)

  return (
    <Routes>
      {isSEOs(employee?.employeeData?.M15_Employee_id!)
        ?
        <Route index element={<Navigate to='add_product_sku' />} />
        : <Route index element={<Navigate to='add_product' />} />
      }
      <Route path='Product_category' element={<CategoryCRUD setSelectedId={props.setSelectedId} />} />
      <Route path='add_product_sku/*'  >
        <Route index element={<AddProductSKU setSelectedId={props.setSelectedId} />} />
        {/* {!isSEOs(employee?.employeeData?.M15_Employee_id!) && <Route path='pricing/:id' element={<PricingPage setSelectedId={props.setSelectedId} />} />} */}
      </Route>
      {
        !isSEOs(employee?.employeeData?.M15_Employee_id!) &&
        <>
          <Route path='brand' element={<BrandCRUD setSelectedId={props.setSelectedId} />} />
          <Route path='add_product' element={<AddProduct setSelectedId={props.setSelectedId} />} />
          {/* <Route path='price_upload' element={<ExcelUploadPrice setSelectedId={props.setSelectedId} />} /> */}
          <Route path='warehouse_details/*' element={<WarehouseRoot setSelectedId={props.setSelectedId} />} />
          <Route path='purchase/*' element={<PurchaseList setSelectedId={props.setSelectedId} />} />
          <Route path='stock/*' element={<StockCRUD setSelectedId={props.setSelectedId} />} />
          <Route path='ecommerceStock/*' element={<EcommercStockCRUD setSelectedId={props.setSelectedId} />} />
          <Route path='stockUpload/*' element={<ExcelUpload setSelectedId={props.setSelectedId} />} />
        </>
      }
    </Routes>
  )
}
